export default values => values.filter(value => value).join(', ');
